export function setState(state, keyValue = []) {
  if (!Array.isArray(keyValue)) {
    return;
  }
  state[keyValue[0]] = keyValue[1];
}

export function setBudgetSummary(state, budgetSummary) {
  state.budgetSummary = budgetSummary;
  state.budgetSummaryLoading = false;
}

export function clearBudgetTransactions(state) {
  state.budgetTransactions = [];
}

export function addBudgetTransactions(state, transactions) {
  if (Array.isArray(transactions)) {
    state.budgetTransactions = [...state.budgetTransactions, ...transactions];
    state.budgetTransactionsLoading = false;
  }
}
